module.exports = __webpack_public_path__ + "img/icons/location--red.svg";